module.exports = __webpack_public_path__ + "img/mavryk.77175b4c.svg";